import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconReactionLoveFilled, homefieldIconReactionLoveOutlined } from '@dsg-tech/homefield-angular-icons';

import { FavoritesIconComponent } from './favorites-icon.component';

@NgModule({
	declarations: [FavoritesIconComponent],
	imports: [
		CommonModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule
	],
	exports: [
		FavoritesIconComponent
	]
})
export class FavoritesIconModule {
	/* istanbul ignore next */
	constructor(public homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		/* istanbul ignore next */
		homefieldIconsLibraryService.registerIcons([
			homefieldIconReactionLoveFilled,
			homefieldIconReactionLoveOutlined
		]);
	}
}
